module.exports = __webpack_public_path__ + "img/ld-img-9.fe9fdc72.png";